
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { OdgReportingService } from './services/odgReporting.service';
import { OdgReportingApiService } from './services/api/odg-reporting.apiservice';
import { ExportsOdgComponent } from './exports-odg/exports-odg.component';
// import { OdgApiService } from './services/api/odg.apiservice';
// import { OdgService } from './services/odg.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule
  ],
  declarations:
  [
    ExportsOdgComponent
  ],
  exports: [
    ExportsOdgComponent
  ],
  providers: [
    OdgReportingApiService,
    OdgReportingService
  ]
})
export class OdgReportingModule { }
